import dynamic from "next/dynamic";
import { useEffect, useState } from "react";

const ReCAPTCHA = dynamic(() => import("react-google-recaptcha"), {
  ssr: false,
});

const CaptchaField = ({
  handleRecaptchaChange,
  name,
  // recaptchaRef,
  errorMessage,
  required = true,
  isValid,
}) => {
  const [isClient, setIsClient] = useState(false);
  // const recaptcha = useRef();

  const recaptchaHandlerCustom = (response) => {
    handleRecaptchaChange(response, name);
  };

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    return null;
  }

  return (
    <>
      <ReCAPTCHA
        // ref={recaptchaRef}
        sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
        onChange={(response) => recaptchaHandlerCustom(response)}
      />
      {!!required && !isValid && (
        <span className="EditingFormErrorLabel">{errorMessage}</span>
      )}
    </>
  );
};

export default CaptchaField;
